import React from "react";
import { MapTo } from "@adobe/aem-react-editable-components";
import { ButtonList, TeaserTextProps } from "./TeaserText.types";
import { TeaserTextContainer } from "./TeaserText.style";
import sanitizeHtml from "sanitize-html";
import sanitizeWhiteList from "../sanitize-html.whitelist";
import Button from "../MicroComponents/Button/Button";
import { blankSpace } from "../Hero/Hero";
import { tagCtaClick } from "../../utils/tagManager";
import { ModalMia } from "../ModalMia/ModalMia";

export default function TeaserText({
  id,
  order,
  backgroundColor,
  borderColor,
  isBorder,
  title,
  titleUpper,
  titleColor,
  subtitle,
  subtitleUpper,
  subtitleColor,
  text,
  textColor,
  buttonList,
  image,
  imageAlt,
  imageTitle,
  fontSizeDeskTitle,
  fontSizeMobileTitle,
  fontSizeDeskSub,
  fontSizeMobileSub,
  pageImovelClassSuffix,
  cqPath,
  sensiaVariation = "",
}: TeaserTextProps) {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [modalProps, setModalProps] = React.useState<ButtonList | null>(null);
  const pageImovelClassName = {
    padding: `page-imovel-${pageImovelClassSuffix}-padding`,
    content: `page-imovel-${pageImovelClassSuffix}-content`,
  };

  const handleTagCtaClick = (text: string, id: string) => {
    tagCtaClick({
      element_text: text,
      element_location: "Body",
      content_id: id,
      section_title: title,
    });
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalProps(null);
    const currentUrl = window.location.href;
    const newUrl = currentUrl.split('#')[0];
    window.history.replaceState(null, '', newUrl);
  };

  return (
    <TeaserTextContainer
      id={id}
      $order={order}
      $titleColor={titleColor}
      $subtitleColor={subtitleColor}
      $textColor={textColor}
      $titleUpper={titleUpper}
      $subtitleUpper={subtitleUpper}
      $backgroundColor={backgroundColor}
      $borderColor={borderColor}
      $isBorder={isBorder}
      $fontSizeDeskTitle={fontSizeDeskTitle}
      $fontSizeMobileTitle={fontSizeMobileTitle}
      $fontSizeDeskSub={fontSizeDeskSub}
      $fontSizeMobileSub={fontSizeMobileSub}
      className={pageImovelClassName.padding}
    >
      {title && <h2 className={`teaser__title ${sensiaVariation && "sensia-title-mobile"}`}>{title}</h2>}
      <div className="teaser">
        <div className={`teaser__content ${pageImovelClassName.content}`}>
          {title && sensiaVariation && (
            <h2 className={`teaser__title ${sensiaVariation && "sensia-title-desk"}`}>{title}</h2>
          )}
          {subtitle && <h2 className="teaser__subtitle">{subtitle}</h2>}
          {image && pageImovelClassSuffix?.includes("borderless") && (
            <img
              className={`teaser__image-borderless ${sensiaVariation}`}
              src={blankSpace(image)}
              title={imageTitle}
              alt={imageAlt}
            />
          )}
          {text && (
            <div
              className={`teaser__text ${sensiaVariation && "sensia-margin"}`}
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(text, sanitizeWhiteList),
              }}
            ></div>
          )}
          {buttonList && buttonList.length > 0 && (
            <div className={`teaser__buttons ${sensiaVariation && "sensia-button"}`}>
              {buttonList.map((item: ButtonList, index: number) => (
                <Button
                  id={item.buttonId}
                  key={index}
                  type={item.buttonType}
                  text={item.buttonText}
                  fontColor={item.buttonTextColor}
                  backgroundColor={item.buttonBackgroundColor}
                  click={() => {
                    if (item.isModal) {
                      setIsModalOpen(true);
                      setModalProps(item);
                    } else {
                      window.open(item.buttonLink, item.buttonTarget);
                    }
                    handleTagCtaClick(item.buttonText ?? "", item.buttonId);
                  }}
                />
              ))}
            </div>
          )}
        </div>
        {image && (
          <img
            className={`teaser__image image-${pageImovelClassSuffix} ${sensiaVariation}`}
            src={blankSpace(image)}
            title={imageTitle}
            alt={imageAlt}
          />
        )}
      </div>
      {isModalOpen && modalProps && (
        <ModalMia
          onClose={closeModal}
          idModal={modalProps.idModal}
          backgroundColor={modalProps.modalBackgroundColor}
          modalTitle={modalProps.modalTitle}
          modalTitleColor={modalProps.modalTitleColor}
          modalButton={modalProps.modalButton}
          modalDescription={modalProps.modalDescription}
          modalDescriptionColor={modalProps.modalDescriptionColor}
          nameLabel={modalProps.nameLabel}
          namePlaceHolder={modalProps.namePlaceHolder}
          nameError={modalProps.nameError}
          nameRequired={modalProps.nameRequired}
          nameRequiredText={modalProps.nameRequiredText}
          emailLabel={modalProps.emailLabel}
          emailPlaceHolder={modalProps.emailPlaceHolder}
          emailError={modalProps.emailError}
          emailRequired={modalProps.emailRequired}
          emailRequiredText={modalProps.emailRequiredText}
          celularLabel={modalProps.celularLabel}
          celularPlaceHolder={modalProps.celularPlaceHolder}
          celularError={modalProps.celularError}
          celularRequired={modalProps.celularRequired}
          celularRequiredText={modalProps.celularRequiredText}
          estadoLabel={modalProps.estadoLabel}
          estadoPlaceHolder={modalProps.estadoPlaceHolder}
          estadoRequired={modalProps.estadoRequired}
          estadoRequiredText={modalProps.estadoRequiredText}
          cidadeLabel={modalProps.cidadeLabel}
          cidadePlaceHolder={modalProps.cidadePlaceHolder}
          cidadeRequired={modalProps.cidadeRequired}
          cidadeRequiredText={modalProps.cidadeRequiredText}
          checkBoxText={modalProps.checkBoxText}
          checkBoxRequired={modalProps.checkBoxRequired}
          checkBoxRequiredText={modalProps.checkBoxRequiredText}
          siteKey={modalProps.siteKey}
          link={modalProps.modalLink ?? modalProps.buttonLink ?? ""}
          cqPath={cqPath}
        />
      )}
    </TeaserTextContainer>
  );
};
